import { HttpClient } from '../httpClient';
import ProgramContactResponse from '../responses/programContactResponse';
import { BaseResponse } from '../responses/baseResponse';
import ProgramContactRequest from '../requests/programContactRequest';

const httpClient = new HttpClient();

export const getProgramContact = async (ProgramContactId: number) => {
  return httpClient.get<ProgramContactResponse>({
    url: `/v1/ProgramContacts/${ProgramContactId}`,
    requiresToken: true,
  });
};

export const getProgramContactsByProgramId = async (programId: number) => {
  return httpClient.get<ProgramContactResponse>({
    url: `/v1/ProgramContacts/ByProgram/${programId}`,
    requiresToken: true,
  });
};

export const createProgramContact = async (ProgramContactrequest: ProgramContactRequest) => {
  return httpClient.post<ProgramContactResponse>({
    url: '/v1/admin/ProgramContacts',
    payload: ProgramContactrequest,
    requiresToken: true,
  });
};

export const updateProgramContact = async (
  ProgramContactId: number,
  ProgramContactrequest: ProgramContactRequest
) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/admin/ProgramContacts/${ProgramContactId}`,
    payload: ProgramContactrequest,
    requiresToken: true,
  });
};

export const deleteProgramContact = async (ProgramContactId: number) => {
  return httpClient.delete<BaseResponse>({
    url: `/v1/admin/ProgramContacts/${ProgramContactId}`,
    requiresToken: true,
  });
};
